<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        @change="onChangeReds($event)"
      />
      <span class="orange"></span> Com exodontia
      <span
        v-b-tooltip.hover
        title="Pessoas com exodontias"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        @change="onChangeGreens($event)"
      />
      <span class="green"></span> Sem exodontia
      <span
        v-b-tooltip.hover
        title="Pessoas sem exodontias"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          // this.$emit('resetarNome', this.setRed)
          this.greens = false
          this.reds = true
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.$emit('exibirVerdes', event.target.checked)
    },
  },
}
</script>

<style></style>
